import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ConsumersActions } from './consumers.actions';
import { ConsumersSelectors } from './consumers.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {MenuParams, MenuParamsContext} from '@emm/core/models/menu-key.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {Consumer} from '@emm/core/models/consumer.model';


export interface ConsumerQueries extends AsyncActionQueries {
    all$: Observable<Consumer[]>;
    menuParams$: Observable<MenuParams>;
    menuParamsContext$: Observable<MenuParamsContext>;
    selected$: Observable<Consumer>;
}

@Injectable({
    providedIn: 'root'
})
export class ConsumersStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, ConsumersSelectors);
    }

    dispatch = {
        selectConsumer: (tag: string) => this.store.dispatch(ConsumersActions.select({ tag })),
        deleteConsumer: (tag: string) => this.store.dispatch(ConsumersActions.delete({ tag })),
        reloadConsumers: () => this.store.dispatch(ConsumersActions.reloadConsumers()),
        getAllConsumers: () => this.store.dispatch(ConsumersActions.loadAll()),
    };



    queries: ConsumerQueries = {
        all$: this.selectNonNil(ConsumersSelectors.getValidAll),
        selected$: this.select(ConsumersSelectors.getSelected),
        menuParams$: this.selectNonNil(ConsumersSelectors.getMenuParams),
        menuParamsContext$: this.selectNonNil(ConsumersSelectors.getMenuParamsContext),
        ...this.asyncActionQueries,
    };




}
